// extracted by mini-css-extract-plugin
export default {"container":"login-statistics_container__QA5wM","title":"login-statistics_title__oMqKt","loading":"login-statistics_loading__Kb5ZU"};